export const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const CALENDAR_DATE_FORMAT = 'mm-dd-yy';
export const DATE_FORMAT = 'MM-DD-YYYY';
export const Y_M_D_DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_24_FORMAT = 'HH:mm:ss';
export const AM_PM_TIME_FORMAT = 'hh:mm A';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_24_FORMAT}`;
export const DATE_TIME_FORMAT_AM_PM = `${DATE_FORMAT} ${AM_PM_TIME_FORMAT}`;
export const TIME_FORMAT_FIXED_SECONDS = 'HH:mm:00';
